import { Component } from "@angular/core";
import {
  faMagnifyingGlass,
  faBroom,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { CustomerEnquiryService } from "src/app/services/autopac/customer-enquiry.service";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-customer-enquiry",
  templateUrl: "./customer-enquiry.component.html",
  styleUrls: ["./customer-enquiry.component.css"],
})
export class CustomerEnquiryComponent {
  faMagnifyingGlass = faMagnifyingGlass;
  faBroom = faBroom;

  form: FormField[] = [
    {
      type: "select",
      id: "searchOption",
      label: "Search criteria",
      value: 1,
      options: [
        { value: 1, display: "Buyer's name" },
        { value: 2, display: "Buyer's NRIC" },
        { value: 3, display: "Buyer's order number" },
        { value: 4, display: "Registration number" },
        { value: 5, display: "Invoice number" },
        { value: 6, display: "Engine number" },
        { value: 7, display: "Chassis number" },
      ],
    },
    {
      type: "text",
      id: "searchText",
      label: "Search text",
      value: "",
    },
  ];

  tableEntries: any[] = [];
  tableHeaders = [
    { title: "BUYER'S ORDER NUMBER", type: "data", id: "RefNo" },
    { title: "CONTRACT NUMBER", type: "data", id: "ContractNo" },
    { title: "BUYER'S NAME", type: "data", id: "Name" },
    { title: "BUYER'S NRIC", type: "data", id: "CustomerIc" },
    { title: "REGISTER NUMBER", type: "data", id: "RegisterNumber" },
    { title: "INVOICE NUMBER", type: "data", id: "InvoiceNumber" },
    { title: "SALES CONSULTANT", type: "data", id: "SalesmanCode" },
    { title: "VIN NUMBER", type: "data", id: "CaseNumber" },
    { title: "ENGINE NUMBER", type: "data", id: "EngineNumber" },
    { title: "CHASSIS NUMBER", type: "data", id: "ChasisNumber" },
    { title: "MODEL", type: "data", id: "ModelShortDesc" },
  ];

  constructor(
    private customerEnquiryService: CustomerEnquiryService,
    private notifier: NotifierService,
  ) {}

  search(): void {
    const searchOption = this.getField("searchOption").value;
    const searchText = this.getField("searchText").value.trim();

    if (!searchText) {
      this.notifier.notify("error", "Please enter a search text");
      return;
    }

    this.customerEnquiryService
      .searchCustomer(searchOption, searchText)
      .subscribe(
        (response) => {
          if (response.body.length > 0) {
            this.tableEntries = response.body;
          } else {
            this.notifier.notify("error", "No data found");
          }
        },
        (error) => {
          console.error("Error during search:", error);
        },
      );
  }

  clear(): void {
    this.getField("searchText").value = "";
    this.getField("searchOption").value = 1;
    this.tableEntries = [];
  }

  getField(id: string): FormField {
    return (
      this.form.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: undefined,
      }
    );
  }
}
